module.exports = __webpack_public_path__ + "img/sample_ware_list_horizontal.4a8bbdf2.png";